import { format } from 'date-fns';

import { EMPTY_PLACEHOLDER } from './constants';
import { toDateOrNull } from './parse';
import type { DateInput } from './types';

/**
 * 24-hour by default. An admin console that mixes 12-hour and 24-hour columns
 * produces sorting mistakes that look like data mistakes.
 */
const DEFAULT_TIME_PATTERN = 'HH:mm';

/**
 * Formats a wall-clock time in the viewer's local zone. Returns `—` when the
 * input is not a date.
 */
export function formatTime(value: DateInput, pattern: string = DEFAULT_TIME_PATTERN): string {
  const date = toDateOrNull(value);
  return date === null ? EMPTY_PLACEHOLDER : format(date, pattern);
}
